<template>
  <div id="bar4">
    <li v-for="(item, index) in items" :key="index">
      <h2>{{ item.number }}</h2>
      <img src="static/kanbanbg.png" alt="" />
      <p>{{ item.name }}</p>
    </li>
  </div>
</template>
<script>
import lytable from "../lytable.vue";
export default {
  components: { lytable },
  data() {
    return {
      items: [],
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 12,
        sort: 2,
        startTime: "",
      },

      //http://120.25.144.155:8001/gps-d?carld=3630#/login
      //http://120.25.144.155:8001/gps-d?carld=3630
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },

    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countDriverState",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        
        var obj = {
          0: {
            name: '空闲',
            list: []
          }, 1: {
            name: '任务中',
            list: []
          }
        }
        for (let i = 0; i < data.length; i++) {
          obj[data[i].state].list.push(data[i]);
        }
        var t = [
          {
            name: "总人数",
            number: data.length,
          },
          {
            name: "空闲人数",
            number: obj[0].list.length,
          },
          {
            name: "出车人数",
            number: obj[1].list.length,
          },
        ];
 
 
        this.items = t;
      });
    },
  },
};
</script>
<style>
#bar4 {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 10px;
}

#bar4 li img {
  width: 90%;
  opacity: 0.7;
}

#bar4 li h2 {
  font-size: 30px;
  font-weight: bold;
  color: #00fcfa;
}

#bar4 li p {
  color: #00fcfa;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/paigongxiangmu.vue